import "react-toastify/dist/ReactToastify.css";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { baseUrlForEnterprise } from "../../variables/variables";
import { arbitratorAdd, arbitratorEdit } from "../../adapter/arbitratorAdapter";

function ArbitratorEdit({ EditData, updated }) {
  const navigate = useNavigate();
  const [selectedBlockedEnterprises, setSelectedBlockedEnterprises] = useState(
    EditData ? EditData[0].blockedEnterprises : []
  );
  const [Edit, setEdit] = useState(true);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [formData, setFormData] = useState({
    pseudonym: "",
    category: "",
    availabilityClass: "",
    blockedEnterprises: [],
  });
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    getValues,
  } = useForm();

  const handleChange = (event) => {
    setSelectedBlockedEnterprises(event.target.value);
    setValue("blockedEnterprises", event.target.value);
    setFormData({ ...formData, blockedEnterprises: event.target.value }); // Update the form state
  };

  const handleValueChnage = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleDelete = (valueToDelete) => {
    const updatedBlockedEnterprises = formData?.blockedEnterprises?.filter(
      (chip) => chip !== valueToDelete
    );
    setFormData({ ...formData, blockedEnterprises: updatedBlockedEnterprises });
    console.log(updatedBlockedEnterprises);
    setSelectedBlockedEnterprises(updatedBlockedEnterprises);
    setValue("blockedEnterprises", updatedBlockedEnterprises); // Update the form state
  };

  useEffect(() => {
    if (EditData) {
      setFormData(EditData[0]);
    }
  }, [EditData]);

  useEffect(() => {
    setLoading(true);
    const settings = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    axios
      .get(baseUrlForEnterprise, settings)
      .then((res) => {
        if (res.data.status !== "success") {
          setLoading(false);
          toast.error("Something went wrong !");
          setData([]);
          return;
        }

        const mydata = res.data.data.map((item) => item.name);
        setData(mydata);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.message);
        setData([]);
        return;
      });
  }, []);

  const onSubmit = () => {
    if (Edit) {
      setLoading(true);
      if (EditData) {
        const info = arbitratorEdit(formData.id, formData);

        info.then((result) => {
          setLoading(false);
          handleSubmissionResult(result);
        });
      }
    } else {
      setEdit(true);
    }
  };

  const handleSubmissionResult = (result) => {
    if (result.status === "success") {
      toast.success(result.message);
      setFormData({
        pseudonym: "",
        category: "",
        availabilityClass: "",
        blockedEnterprises: [],
      });
      updated(true);
    } else {
      toast.error(result.message);
    }
  };

  const resrthandle = () => {
    reset();
    setSelectedBlockedEnterprises([]); // Reset the blocked enterprises state
  };

  return (
    <div className="navView">
      <ToastContainer />
      <div style={{ height: "100vh" }}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{
            position: "fixed",
            height: "400px",
            overflow: "scroll",
            width: "300px",
          }}
        >
          <Stack sx={{ padding: "1em" }} spacing={2}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                id="outlined-basic"
                label="Arbitrator ID"
                variant="outlined"
                type="text"
                name="pseudonym"
                disabled={true}
                // {...register({
                //   required: {
                //     value: true,
                //     message: "Any Arbitrator ID is required!",
                //   },
                // })}

                error={Boolean(errors.pseudonym)}
                helperText={errors.pseudonym?.message}
                value={formData.pseudonym}
              />
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="category-label">Category</InputLabel>
              <Select
                fullWidth
                labelId="category-label"
                id="outlined-basic"
                label="Category "
                variant="outlined"
                type="text"
                name="category"
                onChange={(e) => {
                  handleValueChnage(e);
                }}
                disabled={!Edit}
                error={Boolean(errors.category)}
                helperText={errors.category?.message}
                value={formData.category}
              >
                {["C2", "C1", "B", "A3", "A2", "A1", "HC"].map((ele, inde) => {
                  return (
                    <MenuItem key={inde} value={ele}>
                      {ele}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="availability-label">Availability</InputLabel>
              <Select
                labelId="availability-label"
                id="availability"
                label="Availability"
                name="availabilityClass"
                disabled={!Edit}
                value={formData.availabilityClass}
                onChange={(e) => {
                  handleValueChnage(e);
                }}
                error={Boolean(errors.availabilityClass)}
                helperText={errors.availabilityClass?.message}
              >
                <MenuItem value="0">0. No availability</MenuItem>
                <MenuItem value="1">1. Restricted availability</MenuItem>
                <MenuItem value="2">2. Limited availability</MenuItem>
                <MenuItem value="3">3. Moderate availability</MenuItem>
                <MenuItem value="4">4. Sufficient availability</MenuItem>
                <MenuItem value="5">5. Total availability</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="blocked-enterprises-label">
                Blocked Enterprises
              </InputLabel>
              <Select
                labelId="blocked-enterprises-label"
                id="blocked-enterprises"
                disabled={!Edit}
                multiple
                value={formData.blockedEnterprises}
                onChange={handleChange}
                input={<OutlinedInput label="Blocked Enterprises" />}
                renderValue={(selected) => (
                  <Stack gap={1} direction="row" flexWrap="wrap">
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={value}
                        onDelete={() => handleDelete(value)}
                        deleteIcon={
                          <CancelIcon
                            onMouseDown={(event) => event.stopPropagation()}
                          />
                        }
                      />
                    ))}
                  </Stack>
                )}
                MenuProps={MenuProps}
              >
                {data.map((name) => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <div
            style={{ display: "flex", justifyContent: "center", gap: "1em" }}
          >
            {Edit ? (
              <Button
                startIcon={<SaveIcon />}
                disabled={loading}
                type="submit"
                variant="contained"
                sx={{ mt: 2, mb: 2 }}
                style={{
                  background:
                    "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
                }}
              >
                {Edit ? "SAVE" : "EDIT"}
                {loading && (
                  <CircularProgress className="buttonLoading" size={16} />
                )}
              </Button>
            ) : (
              <Button
                startIcon={<SaveIcon />}
                disabled={loading}
                type="submit"
                variant="contained"
                sx={{ mt: 2, mb: 2 }}
                style={{
                  background:
                    "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
                }}
              >
                {Edit ? "SAVE" : "EDIT"}
                {loading && (
                  <CircularProgress className="buttonLoading" size={16} />
                )}
              </Button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default ArbitratorEdit;
